"use strict";
exports.__esModule = true;
exports.StatusCodeEnum = void 0;
/**
 * HTTP Status code enum
 */
var StatusCodeEnum;
(function (StatusCodeEnum) {
    StatusCodeEnum[StatusCodeEnum["OK"] = 200] = "OK";
    StatusCodeEnum[StatusCodeEnum["Created"] = 201] = "Created";
    StatusCodeEnum[StatusCodeEnum["NoContent"] = 204] = "NoContent";
    StatusCodeEnum[StatusCodeEnum["BadRequest"] = 400] = "BadRequest";
    StatusCodeEnum[StatusCodeEnum["InternalServerError"] = 500] = "InternalServerError";
    StatusCodeEnum[StatusCodeEnum["Found"] = 302] = "Found";
})(StatusCodeEnum = exports.StatusCodeEnum || (exports.StatusCodeEnum = {}));
